const SvgInternalJobs = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.12}
      d="M17.002 15.2285C17.0283 15.24 17.0638 15.258 17.1338 15.293L20.8809 17.166L12.1338 21.54C12.0637 21.5751 12.0283 21.593 12.002 21.6045H11.998C11.9717 21.593 11.9363 21.5751 11.8662 21.54L3.11816 17.166L6.86621 15.293C6.93626 15.2579 6.97169 15.24 6.99805 15.2285L7 15.2275L7.00195 15.2285C7.02831 15.24 7.06374 15.2579 7.13379 15.293L11.4189 17.4346C11.5242 17.4872 11.6618 17.562 11.8154 17.5908C11.9371 17.6136 12.0629 17.6136 12.1846 17.5908C12.3382 17.562 12.4758 17.4872 12.5811 17.4346L16.8662 15.293C16.9362 15.258 16.9717 15.24 16.998 15.2285L17 15.2275L17.002 15.2285Z"
      fill="currentColor"
      stroke="currentColor"
    />
    <path
      d="M7 14.6667L2 17.1667L11.6422 21.9878C11.7734 22.0534 11.839 22.0862 11.9078 22.0991C11.9687 22.1105 12.0313 22.1105 12.0922 22.0991C12.161 22.0862 12.2266 22.0534 12.3578 21.9878L22 17.1667L17 14.6667M4.43675 10.7598L2 12.1666L11.6422 16.9878C11.7734 17.0534 11.839 17.0862 11.9078 17.0991C11.9687 17.1105 12.0313 17.1105 12.0922 17.0991C12.161 17.0862 12.2266 17.0534 12.3578 16.9878L22 12.1666L19.5632 10.7598"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 1.4729V11.9998M6.73657 6.73637L12 11.9998L17.2635 6.73637"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgInternalJobs;
